export default "__VITE_ASSET__BBs2NtJ2__"